import { GridColDef } from "@mui/x-data-grid";

import { columsOptions } from "assets/css";

import {
  staySortComparator,
  stayRenderCell,
  distanceSortComparator,
  distanceRenderCell,
  batterySortComparator,
  batteryRenderCell,
  locationFilterOperators,
  locationSortComparator,
  locationRenderCell,
  firstReceiveTimeSortComparator,
  firstReceiveTimeRenderCell,
  lastReceiveTimeSortComparator,
  lastReceiveTimeRenderCell,
  batteryFilterOperators,
} from "../dataGridOptions";
import { useI18n } from "i18n";

const useAttendanceGridColumns = (): GridColDef[] => {
  const { t } = useI18n();

  return [
    { field: "id", headerName: t("field.id"), ...columsOptions, width: 70 },
    {
      field: "name",
      headerName: t("field.name"),
      ...columsOptions,
      width: 250,
    },
    {
      field: "stay",
      headerName: t("attendance.column.stay"),
      ...columsOptions,
      width: 150,
      sortComparator: staySortComparator,
      renderCell: stayRenderCell,
    },
    {
      field: "distance",
      headerName: t("attendance.column.distance"),
      ...columsOptions,
      width: 150,
      sortComparator: distanceSortComparator,
      renderCell: distanceRenderCell,
    },
    {
      field: "battery",
      headerName: t("attendance.column.battery"),
      ...columsOptions,
      width: 100,
      filterOperators: batteryFilterOperators,
      sortComparator: batterySortComparator,
      renderCell: batteryRenderCell,
    },
    {
      field: "classroomNumber",
      headerName: t("field.roomNumber"),
      ...columsOptions,
      width: 250,
      filterOperators: locationFilterOperators,
      sortComparator: locationSortComparator,
      renderCell: locationRenderCell,
    },
    {
      field: "firstReceiveTime",
      headerName: t("attendance.column.firstReceiveTime"),
      ...columsOptions,
      width: 250,
      sortComparator: firstReceiveTimeSortComparator,
      renderCell: firstReceiveTimeRenderCell,
    },
    {
      field: "lastReceiveTime",
      headerName: t("attendance.column.lastReceiveTime"),
      ...columsOptions,
      width: 250,
      sortComparator: lastReceiveTimeSortComparator,
      renderCell: lastReceiveTimeRenderCell,
    },
  ];
};

export default useAttendanceGridColumns;
